// extracted by mini-css-extract-plugin
export var banner_bg = "mainBanner-module--banner_bg--0c4f7";
export var banner_btn = "mainBanner-module--banner_btn--2fd8a";
export var banner_info = "mainBanner-module--banner_info--7ba96";
export var banner_mix_heading = "mainBanner-module--banner_mix_heading--ca107";
export var banner_wrap = "mainBanner-module--banner_wrap--18c28";
export var banner_wrap_heading = "mainBanner-module--banner_wrap_heading--2d57e";
export var btn_red = "mainBanner-module--btn_red--2ebe3";
export var business_form_listing = "mainBanner-module--business_form_listing--aef20";
export var clutch_form = "mainBanner-module--clutch_form--76656";
export var clutch_img_list = "mainBanner-module--clutch_img_list--2ce00";
export var clutch_info = "mainBanner-module--clutch_info--1fc97";
export var clutch_list = "mainBanner-module--clutch_list--397ae";
export var clutch_title = "mainBanner-module--clutch_title--e73cc";
export var clutch_wrap = "mainBanner-module--clutch_wrap--919f3";
export var counter_banner_wrap = "mainBanner-module--counter_banner_wrap--4671f";
export var form_grp = "mainBanner-module--form_grp--e33c2";
export var full_col = "mainBanner-module--full_col--a3080";
export var himms_main_banner = "mainBanner-module--himms_main_banner--f3a9b";
export var hireNewbox = "mainBanner-module--hireNewbox--27c33";
export var home_banner = "mainBanner-module--home_banner--02be1";
export var imageBox = "mainBanner-module--imageBox--a143b";
export var input_grp = "mainBanner-module--input_grp--16db9";
export var it_banner = "mainBanner-module--it_banner--bce56";
export var main_banner = "mainBanner-module--main_banner--e0236";
export var picture = "mainBanner-module--picture--e20b5";
export var picture_small = "mainBanner-module--picture_small--2fa47";
export var textBanner = "mainBanner-module--textBanner--bb794";
export var two_col = "mainBanner-module--two_col--839db";
export var ulList = "mainBanner-module--ulList--2cc66";
export var years_section = "mainBanner-module--years_section--84617";